export class SAMLCallback401Response {
    'error';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return SAMLCallback401Response.attributeTypeMap;
    }
    constructor() {
    }
}
